import EditorialGold from "./EditorialGold";
import ClassicExecutive from "./ClassicExecutive";
import MinimalModern from "./MinimalModern";

/* Design registry — used by the picker modal. */
export const TEMPLATES = [
  {
    key: "editorial-gold",
    name: "Editorial Gold",
    tagline: "Dark, cinematic, on-brand with the site.",
    accent: "#e6c769",
    component: EditorialGold,
    preview: {
      /* CSS preview — mirrors the PDF vibe on-screen */
      background: "#06070b",
      color: "#ffffff",
      accent: "#e6c769",
      body: "#a4a7b0",
      titleFont: "'Playfair Display', serif",
      style: "dark",
    },
  },
  {
    key: "classic-executive",
    name: "Classic Executive",
    tagline: "Traditional serif on cream — the boardroom standard.",
    accent: "#101010",
    component: ClassicExecutive,
    preview: {
      background: "#fdfaf3",
      color: "#101010",
      accent: "#101010",
      body: "#3a3a3a",
      titleFont: "'EB Garamond', 'Playfair Display', serif",
      style: "light",
    },
  },
  {
    key: "minimal-modern",
    name: "Minimal Modern",
    tagline: "Clean two-column — dark rail with a bright canvas.",
    accent: "#e6c769",
    component: MinimalModern,
    preview: {
      background: "#fdfdfd",
      color: "#0e1218",
      sidebar: "#0e1218",
      sidebarText: "#ffffff",
      accent: "#e6c769",
      body: "#666a75",
      titleFont: "'Inter', sans-serif",
      style: "twocol",
    },
  },
];

export const findTemplate = (key) => TEMPLATES.find((t) => t.key === key) || TEMPLATES[0];
